import { render, staticRenderFns } from "./loc.vue?vue&type=template&id=fcd8c278"
import script from "./loc.vue?vue&type=script&lang=js"
export * from "./loc.vue?vue&type=script&lang=js"
import style0 from "./loc.vue?vue&type=style&index=0&id=fcd8c278&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports